'use client'

import SiteFaq from '@/components/marketing/SiteFaq'
import faqs from '@/data/home-builder-faqs.json'

export default function HBFaq() {
  return (
    <SiteFaq
      title={
        <>
          Questions builders
          <br />
          ask first.
        </>
      }
      faqs={faqs}
    />
  )
}
